<template>
	<div class="action-flow-node action-flow-node-trigger" style="height: 200px;">
		<div class="action-flow-title">Selection Trigger</div>
		<div class="action-flow-hint">Flow starts from here when a selection is made.</div>
		
		<ActionParamHint label="Component" hint="Which component on what page is being selected?" param-class="param-config"
			param-input-type="select"  param-input-label="Component" @param-change="handleParamChange"
			:param-input-options="[{ value: 'ux-list', label: 'List' }, { value: 'ux-grid', label: 'Grid' }]"
			:param-input-value="parameters.component"
		/>
		<ActionParamHint label="Mote" hint="Single mote selected, or the first one." param-class="param-src" />
		<ActionParamHint label="Selection" hint="Selection of potentially multiple motes at once." param-class="param-src" />
		
		<Handle type="source" id="src-mote" :position="Position.Right" style="top: 135px;" />
		<Handle type="source" id="src-selection" :position="Position.Right" style="top: 175px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	component: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			component: newNodeData.data?.component || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>